import { CampaignFormSliceModel } from '../../Campaign/models/campaign-form-slice.model'
import { SelectAsyncValue } from '../../../components/Form/SelectAsync'
import { Agency } from '../../../types/agency'
import {
  CampaignAcceptanceStatus,
  CampaignStatus,
  CreationFile,
  CreationSchedule,
  MediumPlaceDetails,
  MediumStatus,
  OrganizationAttributes,
  VOOH_OFFER,
} from '../../../types/campaign'
import { Company } from '../../../api/companies/types'
import { User } from '../../../types/user'
import { Errors } from '../../../components/Form/InputError'

export enum VoohMediaFormat {
  MOVE_TV = 'move_tv',
}

export enum VoohSourceMediaFormat {
  MOVE = 'move',
  NETWORK = 'network',
  BRAND = 'brand',
}

export interface VoohCampaignFormSlice {
  cardStatus: CampaignFormSliceModel['cardStatus']
  loadingTemplates: boolean
  acceptanceStatus: CampaignAcceptanceStatus
  form: VoohCampaignForm
  status: CampaignStatus
  note: string
  publishable: boolean
  touched: boolean
  errors: VoohBasicFormErrors
}

export interface VoohCampaignBasicValues {
  agency: SelectAsyncValue<Agency> | null
  clubMediaSource: SelectAsyncValue<VoohBrandNetwork> | null
  name: string
  briefName: string
  startDate: string
  endDate: string
  supervisors: SelectAsyncValue<User>[]
  advertiser: SelectAsyncValue<Company> | null
}
export interface VoohCampaignDetailsValues {
  organizationAttribute: OrganizationAttributes | null
  offer: VOOH_OFFER
  mediaFormat: VoohMediaFormat
  hourFrequency: number | null
  mediaDuration: number | null
}

export interface VoohCampaignForm {
  id: string
  uuid: string
  baseValues: VoohCampaignBasicValues
  detailsValues: VoohCampaignDetailsValues
  mediums: VoohMediaNode[]
  selectedMediums: VoohMediaNode[]
  creations: VoohCreation[]
  mediaTemplates: VoohMediaTemplate[]
}

export interface VoohMediaNode {
  id: number
  type: string
  name: string
  agglomeration_id?: number
  latitude?: string
  longitude?: string
  asId?: string
  address?: string
  showOnTree?: boolean
  building_id?: number
  city_id?: number
  agglomeration?: MediumPlaceDetails
  building?: MediumPlaceDetails
  city?: MediumPlaceDetails
  status?: MediumStatus
  used?: boolean
  brand?: MediumPlaceDetails
  children?: VoohMediaNode[]
}

export type VoohUsedMedia = Pick<VoohMediaNode, 'id' | 'used'>

export interface VoohCreation {
  id: string
  backendId?: number
  archiveReason: string
  archivedAt?: string
  createdAt?: string
  duration: number
  file?: CreationFile
  hourFrequency: number
  details: string
  mediaFormat: VoohMediaFormat
  schedules: CreationSchedule[]
  mediaTree?: VoohMediaNode[]
  thumbnailUrl?: string
  campaign?: {
    id: string
    startDate: string
    endDate: string
  }
  media?: VoohMediaNode[]
}

export type VoohCreationUpdate = Pick<VoohCreation, 'id' | 'details' | 'duration' | 'hourFrequency'>

export type VoohMedia = VoohMediaNode

export interface VoohBasicFormErrors {
  agency: Errors
  name: Errors
  briefName: Errors
  startDate: Errors
  endDate: Errors
}

export const VoohBasicFormErrorsEmpty = {
  agency: [],
  name: [],
  briefName: [],
  startDate: [],
  endDate: [],
}

export interface VoohMediaCheckboxTreeElement {
  label: string
  value: string
  children?: VoohMediaCheckboxTreeElement[]
}

export type BrandNetworkType = VoohSourceMediaFormat.BRAND | VoohSourceMediaFormat.NETWORK

export interface VoohBrandNetwork {
  id: string
  name: string
  fullName: string
  type: BrandNetworkType
}

export interface VoohMediaTemplate {
  id: string
  name: string
  media: VoohMedia[]
}
